import { createBrowserClient } from '@supabase/ssr'

// Singleton instance to prevent multiple GoTrueClient instances
// This is the CANONICAL Supabase client for the entire application
let browserClient: ReturnType<typeof createBrowserClient> | null = null

export function createClient() {
  // Return cached instance if it exists
  if (browserClient) {
    return browserClient
  }

  // Create and cache new instance
  // Using minimal config to avoid sign-out issues during token refresh
  browserClient = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        // Enable auto token refresh
        autoRefreshToken: true,
        // Persist session in localStorage
        persistSession: true,
        // Use localStorage (not sessionStorage) to persist across tabs
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        // Disable URL detection which may cause sign-out cycles
        detectSessionInUrl: false,
        // Keep session alive during refresh
        flowType: 'pkce'
      }
    }
  )

  return browserClient
}
